import { render } from "./HeroiconsOutlineStar.vue?vue&type=template&id=a491062a"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineStar.vue"]])

export default __exports__